export function rgbToHex(red, green, blue) {
  const r = validateColorNumber(red);
  const g = validateColorNumber(green);
  const b = validateColorNumber(blue);

  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

function validateColorNumber(color) {
  return Math.min(255, Math.max(0, color));
}